module.exports = __webpack_public_path__ + "static/media/pattern-purple.02940b4a.svg";